export default __webpack_public_path__ + "static/Average May temp 2005-ce7c1362cc56a112fdaad11f9daf46e5.png";